const CatalogToolbar = ({ children }) => {

  return (

    <>

      {children}

    </>

  );

};

export default CatalogToolbar;